<template>
  <div :class="[
    s[helper.displayDirection],
    !user.login.isLogin ? s.isNotLogin : '',
  ]">

    <!-- ログイン中 -->
    <div
      v-if="user.login.isChecked.isLogin && user.login.isLogin"
      :class="[s.wrap, user.flag === 1 ? '' : s.notWorking]">
      <div :class="s.user">
        <!-- <div :class="s.name">{{ user.username }}</div> -->
        <div :class="s.number">
          <div v-if="user.vehicles[0]">{{ user.vehicles[0].number }}</div>
          <div v-else :class="s.no_vehicle">
            <div>車両を設定してください</div>
            <div>※車両の設定がない場合、配車の対象となりません</div>
            <i class="fa-solid fa-spinner fa-spin" v-if="flag.isLoading.vehicles" />
            <div v-if="!flag.isLoading.vehicles">
              <div
                v-if="vehicles.length"
                class="d-flex align-items-center mt-2"
                :class="s.select_vehicle_wrap">
                <select
                  class="form-control"
                  name="vehicle" id="vehicle"
                  v-model="selectedVehicleId">
                  <option :value="null">選択してください</option>
                  <option
                    v-for="v in vehicles" :key="v.id"
                    :value="v.id">{{ v.label ? `${v.label}　` : '' }}{{ v.name }}</option>
                </select>
                <button :class="[s.btn, s.red]" class="ms-2" :disabled="!selectedVehicleId" @click="setVehicle()">この車両に設定</button>
              </div>
              <div v-if="!vehicles.length">
                <button :class="[s.btn, s.red]" class="mt-2" @click="getVehicles()">車両を選択する</button>
              </div>
            </div>
          </div>
        </div>
        <!-- demand -->
        <div v-if="hasDemandAreas && helper.demandSchedules.length" :class="[s.schedule, !assignedSche && s.is_alert]">
          <div>
            <div v-if="assignedSche" class="d-flex align-items-center justify-content-between">
              <div class="fw-bold">
                <div>{{ assignedSche.label }}</div>
                <div>{{ formatTimestamp(assignedSche.start, 'HH:mm') }} ~ {{ formatTimestamp(assignedSche.end, 'HH:mm') }}</div>
              </div>
              <LargeBtn
                class="ms-2"
                :style="{ width: '120px'}"
                color="blue"
                @click="handleAssignSchedule(999, assignedSche.id)">終了</LargeBtn>
            </div>
            <div v-else>
              <div class="mb-1 fw-bold fc-blue">スケジュールを選択してください。</div>
              <div class="mb-2">スケジュールが設定されていないと予約確認することができません。</div>
              <div class="d-flex align-items-center">
                <LargeBtn
                  v-for="(sche, i) in helper.demandSchedules" :key="sche.id"
                  color="blue"
                  :class="i === 0 ? '' : 'ms-1'"
                  @click="handleAssignSchedule(1, sche.id)">
                  {{ sche.label }} {{ formatTimestamp(sche.start, 'HH:mm') }} ~ {{ formatTimestamp(sche.end, 'HH:mm') }}
                </LargeBtn>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div :class="s.btns" v-if="user.flag === 1">
        <LargeBtn
          v-if="user.role?.role !== 13 && isAllowCruisingUse && user.offices?.length"
          :disabled="isCruisingDisabled"
          @click="createReservation"
          status-name="occupied"
          :office-id="user.offices?.[0]?.id">乗車</LargeBtn>
        <LargeBtn
          v-if="user.role?.role !== 13 && isAllowHandleWaiting"
          @click="registWaitingDriver(1, user.driverStatus.isWaiting ? 'release' : 'regist')"
          status-name="waiting"
          :disabled="isWaitingDisabled"
          :office-id="user.offices?.[0]?.id">{{ user.driverStatus.isWaiting ? '待機解除' : '待機' }}</LargeBtn>
        <LargeBtn
          v-if="isAllowFreeBreak"
          @click="registWaitingDriver(2, user.driverStatus.isBreak ? 'release' : 'regist')"
          status-name="break"
          :disabled="isBreakDisabled"
          :office-id="user.offices?.[0]?.id">{{ user.driverStatus.isBreak ? '休憩解除' : '休憩' }}</LargeBtn>
        <LargeBtn
          v-if="isAllowFreeClosed"
          @click="registWaitingDriver(3, user.driverStatus.isClosed ? 'release' : 'regist')"
          status-name="closed"
          :disabled="isClosedDisabled"
          :office-id="user.offices?.[0]?.id">{{ user.driverStatus.isClosed ? '受付不可解除' : '受付不可' }}</LargeBtn>
      </div>
      <div v-if="hasDemandAreas && user.offices?.[0]?.name === 'tomakomai'" :class="s.btns">
        <router-link to="/demandReservationSearch" class="w-100">
          <LargeBtn color="gray">明日以降の予約を確認</LargeBtn>
        </router-link>
      </div>
      <div :class="s.btns">
        <!-- 自officeにオペレータがいる場合は従来どおり自office宛て。
             オペレータ不在office（has_operator=0）でも宛先となるオーナーofficeが
             見つからない場合は、連絡手段が無くならないよう従来どおり自office宛てを表示する -->
        <div
          v-if="hasOwnOperator || (ownerOfficesLoaded && !ownerOperatorOffices.length)"
          class="w-100"
          @click="openOperatorThread">
          <LargeBtn
            color="gray">オペレーターに連絡</LargeBtn>
        </div>
        <!-- オペレータ不在office（has_operator=0）は実務先areaのオーナーoffice宛て（talkroom）
             対象officeが1つならラベル省略、複数なら（office.label）で区別 -->
        <template v-else>
          <div
            v-for="office in ownerOperatorOffices"
            :key="office.id"
            class="w-100"
            @click="openOwnerOperatorTalkroom(office)">
            <LargeBtn
              color="gray">{{ ownerOperatorOffices.length > 1 ? `オペレーターへ連絡（${office.label}）` : 'オペレーターへ連絡' }}</LargeBtn>
          </div>
        </template>
        <router-link to="/threads/" class="w-100">
          <LargeBtn
            color="gray">チャット一覧</LargeBtn>
        </router-link>
      </div>
      <div
        v-if="user.offices?.[0]?.name === 'abira' && assignedSche"
        :class="s.btns">
        <LargeBtn
          @click="openEditBreakModal(assignedSche)"
          color="purple">配車不可・休憩登録</LargeBtn>
      </div>
    </div>

    <!-- 非ログイン -->
    <div v-else-if="user.login.isChecked.isLogin">
      <NonUserHome />
    </div>

  </div>
</template>

<script>
import { mapState } from 'vuex';
import cf from '@/mixins/commonFunctions.js';
import {
  NonUserHome,
} from '@/components/layouts';
import {
  // StatusPanel,
  LargeBtn,
} from '@/components/parts';

export default {
  name: 'Home',
  mixins: [cf],
  components: {
    NonUserHome,
    LargeBtn,
  },
  data() {
    return {
      flag: {
        isLoading: {
          vehicles: false,
        },
      },
      vehicles: [],
      selectedVehicleId: null,
      selectedScheId: null,
      // 自officeが実務officeとして紐づくareaのオーナーoffice（has_operator=1のみ）
      ownerOperatorOffices: [],
      // 取得完了フラグ（未取得の間は自office宛てフォールバックを出さない）
      ownerOfficesLoaded: false,
    };
  },
  computed: {
    ...mapState(['user', 'helper']),
    footerHeight() {
      return this.helper.isNative.app ? '0px' : 'var(--footer-height)';
    },
    myOffice() {
      return this.user.offices?.[0] || null;
    },
    // has_operator 未取得（undefined）は従来挙動（自office宛て）に倒す
    hasOwnOperator() {
      return Number(this.myOffice?.has_operator ?? 1) !== 0;
    },
    assignedSche() {
      return this.assignedDemand(this.user);
    },
    hasDemandAreas() {
      if (this.user.driverDemandAreas?.length) return true;
      return Boolean(this.user.offices?.[0]?.demandAreas?.length);
    },
    isAllowCruisingUse() {
      return Number(this.user.offices?.[0]?.allow_cruising_use);
    },
    isAllowFreeBreak() {
      return Number(this.user.offices?.[0]?.allow_free_break);
    },
    isAllowHandleWaiting() {
      return Number(this.user.offices?.[0]?.allow_handle_waiting);
    },
    isAllowFreeClosed() {
      return Number(this.user.offices?.[0]?.allow_free_closed);
    },
    isCruisingDisabled() {
      const ds = this.user.driverStatus;
      return (ds.isWorking && !ds.isWaiting)
        || ds.isBreak
        || ds.isClosed
        || ds.isEmergency;
    },
    isWaitingDisabled() {
      const ds = this.user.driverStatus;
      return ds.isBreak
        || ds.isClosed
        || ds.isEmergency;
    },
    isBreakDisabled() {
      const ds = this.user.driverStatus;
      return ds.isClosed || ds.isEmergency;
    },
    isClosedDisabled() {
      const ds = this.user.driverStatus;
      return ds.isEmergency;
    },
  },
  created() {},
  watch: {
    // 自office取得後（ログイン反映後）にオーナーoffice一覧を取得
    'myOffice.id': {
      handler(id) {
        if (id && !this.hasOwnOperator) this.getOwnerOperatorOffices();
      },
      immediate: true,
    },
  },
  methods: {
    /** ローディング表示 */
    showLoading() {
      const args = { modalName: 'modalLoadingBallScaleRippleMultiple' };
      this.$store.dispatch('modal/loadings/showModal', args, { root: true });
    },
    /** ローディング終了 */
    hideLoading() {
      this.$store.dispatch('modal/loadings/hideModal', null, { root: true });
    },

    createReservation() {
      if (this.user.vehicles?.[0]?.flag !== 1) return alert('車両を選択してください。');
      if (this.isCruisingDisabled) {
        alert('待機中か空車時にのみ乗車登録が可能です。');
        return;
      }
      this.showLoading();

      if (this.user.offices?.[0]?.areas.length) {
        this.createDispatch();
        return;
      }

      const data = {
        route: 3, // 流し
        flag: 1,
        driver_id: this.user.id,
      };
      this.axios({
        method: 'POST',
        url: '/v1/reservation/create',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.message === 'This driver cannot accept cruising') {
            alert('流し乗車は許可されていません。管理者にご確認ください。');
            this.hideLoading();
            return;
          }
          if (res.reservationId) {
            this.createOrder(res.reservationId);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    createOrder(reservationId) {
      if (this.user.vehicles?.[0]?.flag !== 1) {
        alert('車両が選択されていないため、ステータスを変更することができませんでした。');
        this.hideLoading();
        return;
      }
      const data = {
        reservation_id: reservationId,
        driver_id: this.user.id,
        vehicle_id: this.user.vehicles?.[0]?.id,
      };
      this.axios({
        method: 'POST',
        url: '/v1/order/create',
        data,
      })
        .then(() => {
          this.$store.dispatch('user/update');
          this.$store.dispatch('dispatch/getReservations', { hideLoading: true });
          this.hideLoading();
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          alert('乗車の登録に失敗しました。再度お試しください。');
          this.hideLoading();
        });
    },

    createDispatch() {
      if (!this.user.schedules?.[0]) {
        alert('スケジュールが設定されていないため乗車を開始できませんでした。管理者へお問い合わせください。');
        this.hideLoading();
        return;
      }
      const data = {
        route: 3, // 流し
        force_create: true,
        schedule_id: this.user.schedules[0].id,
        area_id: this.user.schedules.area_id,
        request_user_id: this.user.id,
        passengerCount: {},
        datetime: this.formatTimestamp(new Date(), 'YYYY-MM-DD HH:mm:ss'),
      };
      this.axios({
        method: 'POST',
        url: '/v1/dispatch/taxi',
        data,
      })
        .then((response) => {
          const res = response.data;
          const path = res.code ? `/order/?type=dispatch&code=${res.code}` : '/order/';
          this.$router.push(path);
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          alert('乗車の登録に失敗しました。再度お試しください。');
        })
        .finally(() => {
          this.$store.dispatch('dispatch/getDispatches', { hideLoading: true });
        });
    },

    // 休憩登録
    registWaitingDriver(type, updateType) {
      // 現在のステータス確認・エンドポイント判定

      this.showLoading();

      const data = {
        driver_id: this.user.id,
        type,
        update_type: updateType,
      };

      this.axios({
        method: 'POST',
        url: '/v1/waitingDriver/update',
        data,
      })
        .then((response) => {
          const res = response.data;
          console.log(res);
          if (res.message === 'Free break is not allowed in this office.') {
            alert('休憩登録が許可されていません。管理者にご確認ください。');
            this.hideLoading();
            return;
          }
          if (res.message === 'Free closed is not allowed in this office.') {
            alert('受付不可の登録が許可されていません。管理者にご確認ください。');
            this.hideLoading();
            return;
          }
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response.data);
            const messages = {
              'This driver is not inside any taxi stands.': '待機所内に入ってから再度お試しください。',
              'This driver has working order.': '稼働中の配車があります。完了してからお試しください。',
            };
            const errorMessage = messages[error.response.data?.message];
            alert(errorMessage || '処理中にエラーが発生しました。再度お試しください。');
          } else {
            console.log(error);
            alert('処理中にエラーが発生しました。再度お試しください。');
          }
        })
        .finally(() => {
          this.hideLoading();
        });
    },

    // 業務開始時にuser.flagを1に変更
    changeWorkingStatus(flag) {
      cf.ToggleNativeAppLocation(this.helper, flag);
      this.$store.dispatch('user/updateFlag', flag);
    },


    getVehicles() {
      this.flag.isLoading.vehicles = true;
      this.vehicles = [];
      const params = {
        onlyDriverless: 1,
        office_id: this.user.offices[0]?.id,
      };
      if (this.user.role.role === 13) {
        params.isAppDriver = 1;
        params.user_id = this.user.id;
      }
      this.axios({
        method: 'GET',
        url: '/v1/vehicle/get/list',
        params,
      })
        .then((response) => {
          const res = response.data;
          this.vehicles = res.vehicles.data;
        })
        .catch((error) => {
          alert('候補車両の取得に失敗しました。設定画面より再度お試しください。');
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.flag.isLoading.vehicles = false;
        });
    },

    setVehicle() {
      this.showLoading();
      const data = {
        flag: 1,
        user_id: this.user.id,
        vehicle_id: this.selectedVehicleId,
      };

      this.axios({
        method: 'POST',
        url: '/v1/userVehicle/create',
        data,
      })
        .then((response) => {
          const res = response.data;
          if (res.exists) {
            alert('選択された車両は別のユーザーによって使用されているため設定できませんでした。\n該当車両の担当者に車両変更するよう依頼するか、管理者へお問い合わせください。');
            this.getVehicles();
            return;
          }
          alert('車両を変更しました');
          this.$store.dispatch('user/update');
        })
        .catch((error) => {
          alert('車両の変更に失敗しました。\n再度お試しください。');
          if (error.response) console.log(error.response.data);
          else console.log(error);
        })
        .finally(() => {
          this.hideLoading();
        });
    },
    handleAssignSchedule(flag, id) {
      this.showLoading();

      const data = {
        flag,
        demand_schedule_id: id,
        driver_id: this.user.id,
      };

      this.axios({
        method: 'POST',
        url: '/v1/demandScheduleDriver/update',
        data,
      })
        .then(() => {
          this.selectedScheId = null;
          this.$store.dispatch('user/update', { hideLoading: true });
          this.$store.dispatch('dispatch/getReservations');
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
        });
    },

    openEditBreakModal(demandSchedule, demandBreak = null) {
      const args = {
        modalName: 'EditDemandBreak',
        modalTitle: '配車不可時間（ドライバー）',
        modalWidth: '500px',
        data: {
          demandSchedule,
          demandBreak,
        },
      };
      this.$store.dispatch('modal/contents/showModal', args, { root: true });
    },

    openOperatorThread() {
      const userIds = [this.user.id];
      this.$store.dispatch('modal/contents/showModal', {
        modalName: 'ThreadMessages',
        modalTitle: 'オペレーター',
        modalWidth: '95%',
        data: { userIds, officeId: this.user.offices[0]?.id },
      });
    },

    /** 自officeが実務officeとして紐づくareaのオーナーofficeを取得（has_operator=1のみ） */
    async getOwnerOperatorOffices() {
      if (!this.myOffice?.id) return;
      try {
        const res = await this.axios.get('/v1/area/get/list', {
          params: {
            officeIds: [this.myOffice.id],
            includeOperatingOffices: 1,
            withOffice: 1,
            withOperatingOffices: 1,
          },
        });
        const areas = res.data.areas?.data || [];
        const offices = [];
        areas.forEach((area) => {
          // 自officeが実務として紐づき、オーナーが他officeのareaのみ対象
          if (area.office_id === this.myOffice.id) return;
          const isOperating = (area.operatingOffices || []).some((o) => o.id === this.myOffice.id);
          if (!isOperating) return;
          const owner = area.office;
          if (!owner || Number(owner.has_operator) !== 1) return;
          if (!offices.some((o) => o.id === owner.id)) offices.push(owner);
        });
        this.ownerOperatorOffices = offices;
      } catch (e) {
        console.error(e);
      } finally {
        // 失敗時もフォールバック（自office宛て）を表示できるよう完了扱いにする
        this.ownerOfficesLoaded = true;
      }
    },

    /** オーナーofficeのオペレーター宛て新チャット（talkroom） */
    openOwnerOperatorTalkroom(office) {
      this.$store.dispatch('modal/contents/showModal', {
        modalName: 'TalkroomMessages',
        modalTitle: `${office.label}のオペレーター`,
        modalWidth: '95%',
        data: { userIds: [this.user.id], officeIds: [office.id, this.myOffice.id] },
      });
    },
  },
};
</script>

<style lang="scss" module="s">
.wrap {
  &.notWorking {
    text-align: center;
    max-width: 350px;
    margin: 0 auto;
    .user {
      margin-bottom: 32px;
    }
  }
}

.user {
  padding: 0 12px;
  margin: 8px 0;
  .name {
    font-weight: bold;
  }
}

.number {
  .no_vehicle {
    margin: 8px 0 16px;
    padding: 12px 18px;
    border: 1px solid var(--bs-red);
    color: var(--bs-red);
    font-weight: bold;
    > * {
      &:first-child {
        margin-bottom: 8px;
      }
      &:not(:first-child) {
        font-size: 16px;
        > a {
          color: var(--bs-red);
          font-size: 16px;
          text-decoration: underline;
        }
      }
    }
  }
}

.schedule {
  padding: 12px;
  border: 2px solid var(--primary-blue);
  border-radius: 6px;
  &.is_alert {
    background-color: var(--bs-primary-bg-subtle);
    border: 2px solid var(--primary-blue);
  }
}

.btns {
  display: flex;
  padding: 0 12px;
  margin-top: 6px;
  > * {
    &:not(:first-child) {
      margin-left: 6px;
    }
  }
}

.history {
  padding: 0 12px;
  margin-top: 6px;
}

.vertical {
  .btns {
    flex-direction: column;
    > * {
      &:not(:first-child) {
        margin-left: 0;
        margin-top: 6px;
      }
    }
  }
}
</style>
